var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('p',{staticClass:"card__label"},[_vm._v(_vm._s(_vm.mode))]),_c('div',{class:`card__icon card__icon--${_vm.mode}`,domProps:{"innerHTML":_vm._s(require(`@/assets/img/icons/card.svg`))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }